import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold pb-2" }, "COVID-19 Response", -1)
const _hoisted_2 = ["innerHTML"]

import CardTemplate from "@/components/template/CardTemplate.vue"

  interface Props {
    details: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CovidResponse',
  props: {
    details: {}
  },
  setup(__props: any) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", {
        innerHTML: props.details
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})